import api from "src/api";
import { customJs } from "../../../utils/customJs";
import { fireClickEvent } from "../../../events";
import { SPONSORED_ADS_PROVIDER_IDS } from "../../../utils/constants";

const timeToClickStorage = {}

export const isValidStyleId = function (id) {
  return id && id.length === 10 && /\d/.test(id);
};

export const getStyleIdFromUrl = function () {
  const urlParams = new URLSearchParams(window.location.href);
  if (urlParams.has('use') && urlParams.has(`styleId${urlParams.get('use')}`)) {
    const styleOverride = urlParams.get(`styleId${urlParams.get('use')}`);
    if (isValidStyleId(styleOverride)) {
      return styleOverride;
    }
  }

  return null;
}
export const overridePostback = (requestKey, postbackKey, url, clientEventParams) => {
  if (requestKey.length !== postbackKey.length) {
    return clientEventParams;
  }
  for (let i = 0; i < requestKey.length; ++i) {
    const paramValue = Object.fromEntries(new URLSearchParams(url.search))?.[requestKey[i]];
    clientEventParams = { ...clientEventParams, [postbackKey[i]]: paramValue ? paramValue : "" };
    delete clientEventParams[requestKey[i]];
  }

  return clientEventParams;
};

/*
  Params:
    data -> data
    searchParams
    bigQueryObjectParams
*/
export const createBQObject = (data, { clientId, searchTerm, serpLayoutVariant, brand }, { URL, country, sponsoredSearchResults2Style, reqId }) => {
  const style_name = getStyleIdFromUrl() || sponsoredSearchResults2Style;
  const now = new Date();

  let BQData = {
    datetime: now.toISOString(),
    userLocalDatetime: now.toISOString(),
    reqId,
    clientID: clientId,
    brand: (brand && brand !== 'undefined') ? brand : null,
    searchTerm,
    URL,
    variant: serpLayoutVariant,
    style_name,
    userId: data?.userID || window.visitorId,
    country,
    categoryID: data?.category,
  };
  return BQData;
};

export const advertiseClicksData = (item, data, searchParams, { URL, country, sponsoredSearchResults2Style, dublicateResults, index, reqId, gcseShowedTime }) => {
  let BQData = createBQObject(data, searchParams, { URL, country, sponsoredSearchResults2Style, reqId });
  const { type, _type, provider } = item;
  const adType = type === "Ads/ProductAd" || _type === "Ads/ProductAd" ? "productAds" : "sponsoredAds";
  const rGuid = data?.providerRguId || data?.signalParameters?.rguid;

  let domain, title;

  if (adType === 'productAds') {
    domain = item.offer?.seller?.domain || item.offer?.seller?.name;
    title = item.offer?.itemOffered?.name
  } else {
    ({ domain, title } = item);
  }

  BQData = {
    ...BQData,
    adTypeClicked: adType,
    provider,
    index: index,
    advertiserSiteURL: domain,
    advertiserTitle: title,
    fromDuplicateResults: dublicateResults,
    rGuid: rGuid,
    sessionId: window.afSessionId,
  };

  const showedTime = timeToClickStorage[`${BQData.advertiserSiteURL}${index}${adType}`] || gcseShowedTime;
  BQData.timeToClick = Date.now() - showedTime;

  api.pushDataToBQ(BQData, "d2SAdvertiserClicks");
  const clickByProvider = provider === SPONSORED_ADS_PROVIDER_IDS.BING.id ? 'bingd2s' : provider ===
    SPONSORED_ADS_PROVIDER_IDS.GOOGLE.id ? SPONSORED_ADS_PROVIDER_IDS.GOOGLE.name : SPONSORED_ADS_PROVIDER_IDS.YAHOO_SYNDICATION.name;
  window.afAdRequest('click', `v1-s1-b1-${clickByProvider}-click`, provider, BQData.brand);
};

// fillRate logic moved to the ms-search

export const advertiseData = (item, data, searchParams, { URL, country, sponsoredSearchResults2Style, index, reqId }) => {
  let BQData = createBQObject(data, searchParams, { URL, country, sponsoredSearchResults2Style, reqId });

  const { type, _type, provider } = item;
  const adTypeText = type || _type;
  const adType = adTypeText === "Ads/ProductAd" ? "productAds" : "searchAds";
  const rGuid = data?.providerRguId || data?.signalParameters?.rguid;

  let domain, title;

  if (adType === 'productAds') {
    domain = item.offer?.seller?.domain || item.offer?.seller?.name;
    title = item.offer?.itemOffered?.name
  } else {
    ({ domain, title } = item);
  }

  BQData = {
    ...BQData,
    adType,
    index: index,
    advertiserSiteURL: domain,
    advertiserTitle: title,
    provider,
    rGuid: rGuid,
    sessionId: window.afSessionId,
  };

  timeToClickStorage[`${BQData.advertiserSiteURL}${index}${adType === 'productAds' ? 'productAds' : "sponsoredAds"}`] = Date.now();

  api.pushDataToBQ(BQData, "d2SAdvertiser");
  const impressionByProvider = provider === SPONSORED_ADS_PROVIDER_IDS.BING.id ? 'bingd2s' : provider ===
    SPONSORED_ADS_PROVIDER_IDS.GOOGLE.id ? SPONSORED_ADS_PROVIDER_IDS.GOOGLE.name : SPONSORED_ADS_PROVIDER_IDS.YAHOO_SYNDICATION.name;
  window.afAdRequest('impression', `v1-s1-b1-${impressionByProvider}-impression`, provider, BQData.brand);
};

const url = new URL(window.location.href);

export const sendClientEvents = async (
  item,
  type,
  index,
  {
    searchParams,
    sponsoredSearchResults2Style,
    sponsoredSearchResults2AllParams,
    sponsoredSearchResults2OverridePostbackCheck,
    sponsoredSearchResults2OverrideRequestKeys,
    sponsoredSearchResults2OverridePostbackKeys,
    sponsoredSearchResults2ClientImpressionsURL,
    sponsoredSearchResults2PostbackURL,
    postbackConfig,
    rGuid
  }
) => {
  let clientEventParams = {
    q: searchParams.searchTerm,
    clientId: searchParams.clientId,
    brand: searchParams.brand,
    variant: searchParams.serpLayoutVariant || searchParams.variant,
    provider: item.provider === 'yahooSyndication' ? 'YahooD2S' : searchParams.provider,
    type: type,
    position: index,
    date: new Date().toGMTString(),
    advertiser: item.domain || (item.type || item._type === "Ads/ProductAd" ? "ProductAd" : ""),
    style: sponsoredSearchResults2Style,
    filled: item.filled || "yes"
  };
  if (rGuid) clientEventParams.rGuid = rGuid;

  if (sponsoredSearchResults2AllParams) {
    clientEventParams = { ...clientEventParams, ...Object.fromEntries(new URLSearchParams(url.search)) };
  }

  if (window.afExtraParams) {
    clientEventParams = { ...clientEventParams, ...window.afExtraParams };
  }

  if (sponsoredSearchResults2OverridePostbackCheck && sponsoredSearchResults2OverrideRequestKeys && sponsoredSearchResults2OverridePostbackKeys) {
    const requestKeys = sponsoredSearchResults2OverrideRequestKeys
      .trim()
      .split(",")
      .filter(val => val.trim() != "");
    const postbackKeys = sponsoredSearchResults2OverridePostbackKeys
      .trim()
      .split(",")
      .filter(val => val.trim() != "");
    clientEventParams = overridePostback(requestKeys, postbackKeys, url, clientEventParams);
  }
  if (postbackConfig.impressionJS && type === 'impression' && postbackConfig.type === 'customJS') {
    customJs(postbackConfig.impressionJS, clientEventParams);
  }
  let clientEndpoint = type == "impression" ? sponsoredSearchResults2ClientImpressionsURL : sponsoredSearchResults2PostbackURL;
  if (clientEndpoint) {
    clientEndpoint += clientEndpoint.indexOf("?") > -1 ? "&" : "?";
    clientEndpoint += new URLSearchParams(clientEventParams).toString();
    if (type == "impression") {
      return fetch(clientEndpoint).catch(e => console.error(e));
    } else {
      let extraDataParams = {
        searchTerm: searchParams.searchTerm,
        datetime: new Date().toISOString(),
        provider: searchParams.provider,
        userId: window.visitorId,
        reqId: searchParams.reqId,
        URL: searchParams.URL,
        country: searchParams.country,
        style_name: sponsoredSearchResults2Style,
        sessionId: window.afSessionId ? window.afSessionId : null,
        userLocalDatetime: new Date().toISOString()
      };
      if (window.afExtraParams) {
        extraDataParams = { ...extraDataParams, ...clientEventParams };
      }
      navigator.sendBeacon(clientEndpoint, JSON.stringify(extraDataParams));
    }
  }
};

export const clickNotify = (
  item,
  index,
  data,
  {
    searchParams,
    sponsoredSearchResults2Style,
    sponsoredSearchResults2AllParams,
    sponsoredSearchResults2OverridePostbackCheck,
    sponsoredSearchResults2OverrideRequestKeys,
    sponsoredSearchResults2OverridePostbackKeys,
    sponsoredSearchResults2ClientImpressionsURL,
    sponsoredSearchResults2PostbackURL,
    dublicateResults,
    URL,
    country,
    clickPostback,
    targetWindow,
    postbackConfig,
    captcha
  },
  reqId
) => async e => {
  e.stopPropagation();
  e.preventDefault();
  const { facebookPixelId, clickEvent } = postbackConfig;
  fireClickEvent('sponsoredSearchResults2', 0, ['fbclid', 'spx'])
  if (captcha) {
    const captchaParams = {
      reqId,
      hostUrl: window.location.host,
      searchTerm: searchParams.searchTerm,
      clientId: searchParams.clientId,
      brand: searchParams.brand,
      variant: searchParams.serpLayoutVariant || searchParams.variant,
      style: sponsoredSearchResults2Style
    };

    const failed = await captcha.initChallengeCaptcha(index, captchaParams);
    if (failed) {
      captcha.destroyDom();
      return;
    }
  }

  if (window.gtag) {
    window.gtag('event', 'click', {
      "content_type": item.type === "Ads/ProductAd" || item._type === "Ads/ProductAd" ? "product ads" : "sponsored search",
      "variant": searchParams.variant,
    })
  }
  if (clickPostback && targetWindow != '_blank') {
    return;
  }

  let clientEventParams = {
    q: searchParams.searchTerm,
    clientId: searchParams.clientId,
    brand: searchParams.brand,
    variant: searchParams.serpLayoutVariant || searchParams.variant,
    provider: searchParams.provider,
    position: index,
    date: new Date().toGMTString(),
    advertiser: item.domain || (item.type || item._type === "Ads/ProductAd" ? "ProductAd" : ""),
    style: sponsoredSearchResults2Style,
    filled: item.filled || "yes"
  };

  if (sponsoredSearchResults2AllParams) {
    clientEventParams = { ...clientEventParams, ...Object.fromEntries(new URLSearchParams(url.search)) };
  }

  if (sponsoredSearchResults2OverridePostbackCheck && sponsoredSearchResults2OverrideRequestKeys && sponsoredSearchResults2OverridePostbackKeys) {
    const requestKeys = sponsoredSearchResults2OverrideRequestKeys
      .trim()
      .split(",")
      .filter(val => val.trim() != "");
    const postbackKeys = sponsoredSearchResults2OverridePostbackKeys
      .trim()
      .split(",")
      .filter(val => val.trim() != "");
    clientEventParams = overridePostback(requestKeys, postbackKeys, url, clientEventParams);
  }

  clickPostback = true;
  const { dataClickNotify, dataClickNotify1 } = item;

  dataClickNotify && fetch(dataClickNotify).catch(err => console.error(err));
  dataClickNotify1 && await fetch(dataClickNotify1).catch(err => console.error(err));
  // Push data to BQ
  advertiseClicksData(item, data, searchParams, { URL, country, sponsoredSearchResults2Style, dublicateResults, index, reqId });

  let el = e.srcElement || e.target;
  // check if element clicked is a link and bubble up to the nearest a tag
  while (el && (typeof el.tagName == "undefined" || el.tagName.toLowerCase() != "a" || !el.href)) el = el.parentNode;

  if (facebookPixelId && window.fbq && clickEvent) {
    window.fbq("track", clickEvent);
  }
  if (postbackConfig.clickJS) {
    customJs(postbackConfig.clickJS, clientEventParams);
  }

  try {
    if (sponsoredSearchResults2PostbackURL) {
      await sendClientEvents(item, "click", index, {
        searchParams,
        sponsoredSearchResults2Style,
        sponsoredSearchResults2AllParams,
        sponsoredSearchResults2OverridePostbackCheck,
        sponsoredSearchResults2OverrideRequestKeys,
        sponsoredSearchResults2OverridePostbackKeys,
        sponsoredSearchResults2ClientImpressionsURL,
        sponsoredSearchResults2PostbackURL,
        postbackConfig
      });
      !el.target && (targetWindow === '_blank' ? window.open(el.href, targetWindow) : setTimeout(() => window.location.href = el.href, 100));
    } else {
      !el.target && (targetWindow === '_blank' ? window.open(el.href, targetWindow) : setTimeout(() => window.location.href = el.href, 500));
    }
  } catch (err) {
    console.error(err);
  }
};

export const gcseClickNotify = async (
  item,
  index,
  data,
  {
    searchParams,
    sponsoredSearchResults2Style,
    sponsoredSearchResults2AllParams,
    sponsoredSearchResults2OverridePostbackCheck,
    sponsoredSearchResults2OverrideRequestKeys,
    sponsoredSearchResults2OverridePostbackKeys,
    sponsoredSearchResults2ClientImpressionsURL,
    sponsoredSearchResults2PostbackURL,
    dublicateResults,
    URL,
    country,
    clickPostback,
    targetWindow,
    captcha,
    postbackConfig,
    gcseShowedTime,
    rGuid
  },
  reqId,
  useBeaconOnFbConversionRequest,
) => {
  fireClickEvent('sponsoredSearchResults2', 0, ['fbclid', 'spx'], useBeaconOnFbConversionRequest)
  if (captcha) {
    const captchaParams = {
      reqId,
      hostUrl: window.location.host,
      searchTerm: searchParams.searchTerm,
      clientId: searchParams.clientId,
      brand: searchParams.brand,
      variant: searchParams.serpLayoutVariant || searchParams.variant,
      style: sponsoredSearchResults2Style
    };

    const failed = await captcha.initChallengeCaptcha(index, captchaParams);
    if (failed) {
      captcha.destroyDom();
      return;
    }
  }

  if (clickPostback && targetWindow != '_blank') {
    return;
  }

  if (window.gtag) {
    window.gtag('event', 'click', {
      "content_type": item.type === "Ads/ProductAd" || item._type === "Ads/ProductAd" ? "product ads" : "sponsored search",
      "variant": searchParams.variant,
    })
  }

  let clientEventParams = {
    q: searchParams.searchTerm,
    clientId: searchParams.clientId,
    brand: searchParams.brand != "undefined" ? searchParams.brand : "",
    variant: searchParams.serpLayoutVariant || searchParams.variant,
    provider: searchParams.provider,
    position: index,
    date: new Date().toGMTString(),
    advertiser: item.domain || (item.type || item._type === "Ads/ProductAd" ? "ProductAd" : ""),
    style: sponsoredSearchResults2Style,
    filled: item.filled || "yes"
  };

  if (sponsoredSearchResults2AllParams) {
    clientEventParams = { ...clientEventParams, ...Object.fromEntries(new URLSearchParams(url.search)) };
  }

  if (sponsoredSearchResults2OverridePostbackCheck && sponsoredSearchResults2OverrideRequestKeys && sponsoredSearchResults2OverridePostbackKeys) {
    const requestKeys = sponsoredSearchResults2OverrideRequestKeys
      .trim()
      .split(",")
      .filter(val => val.trim() != "");
    const postbackKeys = sponsoredSearchResults2OverridePostbackKeys
      .trim()
      .split(",")
      .filter(val => val.trim() != "");
    clientEventParams = overridePostback(requestKeys, postbackKeys, url, clientEventParams);
  }

  clickPostback = true;
  // Push data to BQ
  if (rGuid) data.providerRguId = rGuid;
  advertiseClicksData(item, data, searchParams, { URL, country, sponsoredSearchResults2Style, dublicateResults, index, reqId, gcseShowedTime });

  if (postbackConfig.type == 'facebookPixel' && window.fbq && postbackConfig.clickEvent) {
    const urlParams = new URLSearchParams(window.location.search);
    let eventId = null;
    const postbackData = {};

    // Step 1: Fallback - use customClickData first (lowest priority)
    if (postbackConfig?.customClickData) {
      try {
        const customData = JSON.parse(postbackConfig.customClickData);
        if (customData.event_id) {
          eventId = customData.event_id; // Will be overridden later if cx_event_id exists
        }
        Object.entries(customData).forEach(([key, val]) => {
          postbackData[key] = val;
        });
      } catch (e) {
        console.error('Invalid JSON in customClickData', e);
      }
    }

    // Step 2: Overried postbackData from URL params
    urlParams.forEach((value, key) => {
      if (key.startsWith('cx_')) {
        if (key === 'cx_event_id') {
          eventId = value;
        } else {
          postbackData[key.replace(/^cx_/, '')] = value;
        }
      }
    });

    if (navigator.sendBeacon) {
      const beaconURLparams = Object.entries(postbackData)
        .map(([key, val]) => `cd[${encodeURIComponent(key)}]=${encodeURIComponent(val)}`)
        .join('&');

      const pixelURL = `https://www.facebook.com/tr?id=${postbackConfig?.facebookPixelId}&ev=${postbackConfig?.clickEvent}&${beaconURLparams}${eventId ? `&eid=${eventId}` : ''}`;

      const eventData = JSON.stringify({
        event: postbackConfig.clickEvent,
        timestamp: new Date().toISOString(),
        ...postbackData,
      });
      navigator.sendBeacon(pixelURL.replace(/¤/g, '&'), eventData);
    } else {
      if (Object.keys(postbackData).length > 0 || eventId) {
        if (eventId) {
          window.fbq("track", postbackConfig.clickEvent, postbackData, { eventID: eventId });
        } else {
          window.fbq("track", postbackConfig.clickEvent, postbackData);
        }
      } else {
        window.fbq("track", postbackConfig.clickEvent);
      }
    }
  }

  if (postbackConfig.clickJS && postbackConfig.type === 'customJS') {
    customJs(postbackConfig.clickJS, clientEventParams);
  }

  if (sponsoredSearchResults2PostbackURL) {
    searchParams.URL = URL;
    searchParams.reqId = reqId;
    searchParams.country = country;
    searchParams.brand = clientEventParams.brand;

    await sendClientEvents(item, "click", index, {
      searchParams,
      sponsoredSearchResults2Style,
      sponsoredSearchResults2AllParams,
      sponsoredSearchResults2OverridePostbackCheck,
      sponsoredSearchResults2OverrideRequestKeys,
      sponsoredSearchResults2OverridePostbackKeys,
      sponsoredSearchResults2ClientImpressionsURL,
      sponsoredSearchResults2PostbackURL,
      postbackConfig,
      rGuid
    });
  }
}

export const handleAuxClick = (clickNotify) => (item, index, data, extraParams, reqId) => (event) => {
  if (event.button === 1) { // Middle mouse button
    // Prevent default behavior of middle click
    event.preventDefault();
    clickNotify(item, index, data, extraParams, reqId)(event);
  }
  // No specific handling for right-clicks (button === 2) as they don't trigger navigation
};

